import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const TractNumber = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Input}
      placeholder="Enter tract number"
      type="text"
      id="tractNumber"
      name="tractNumber"
      label="Tract Number"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default TractNumber;
